import { render, staticRenderFns } from "./BonusManager.vue?vue&type=template&id=326848f8&"
import script from "./BonusManager.vue?vue&type=script&lang=js&"
export * from "./BonusManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports